<template>
  <div class="goods-compare-page-bg">
    <div class="goods-compare">
      <goods-list-title :classname="classname" :show-title="false" />

      <div class="compare-title" style="display: flex; align-items: center; justify-content: space-between;">
        <div  >
          基本信息对比，最多对比<span style="color: #2655AE;font-weight: 700;">4</span>个产品。
        </div>
        <div class="header-actions">
          <label class="diff-label">
            <input class="diff-checkbox" type="checkbox" v-model="showDiffOnly"> 高亮不同项
          </label>
        </div>
      </div>

      <div class="compare-table-wrap">
        <table class="compare-table">
          <thead>
            <tr>
              <th class="label-col">图片</th>
              <th v-for="(item, idx) in fixedSlots" :key="idx" class="goods-col" >
                <div v-if="item" class="goods-thumb" @click="goToGoodsInfo(item.id)">
                  <img :src="item.pic" alt="">
                </div>
                <div v-else class="add-goods-cell" @click="goToAdd">
                  添加产品
                </div>
                <span v-if="item" class="remove-btn" @click="removeGoods(item.id)"><img src="/static/icon/remove-db.svg" alt="移除"></span>
              </th>
            </tr>
            <!-- <tr>
              <th class="label-col">名称</th>
              <th v-for="(item, idx) in fixedSlots" :key="idx" class="goods-col" >
                <div v-if="item" class="goods-thumb" @click="goToGoodsInfo(item.id)">
                  {{ item.name }}
                </div>
                <div v-else class="add-goods-cell" >
                </div>
              </th>
            </tr> -->
          </thead>
          <tbody>
            <tr v-for="(row, rIdx) in compareRows" :key="rIdx"
                :class="{ 'diff-row': showDiffOnly && isDiffRow(row) }">
              <!-- label含<sub>等标签，用v-html渲染才能显示下标，不能用{{ }}文本插值 -->
              <td class="label-col" v-html="row.label"></td>
              <td v-for="(item, idx) in fixedSlots" :key="idx + '-' + rIdx"
                  :class="{
                    'diff-cell': showDiffOnly  && isDiffRow(row),
                    'empty-col': !item,
                    'feature-cell': row.label === '特点'
                  }">
                <!-- 单元格值用v-html渲染，支持sub/sup下标上标和br换行 -->
                <div v-if="row.label === '特点'" class="feature-inner" v-html="item ? getCellVal(row, item) : ''"></div>
                <div v-else class="cell-text" :title="item ? getCellTitle(row, item) : ''" v-html="item ? getCellVal(row, item) : ''"></div>
              </td>
            </tr>
            <tr class="action-row">
              <td class="label-col">操作</td>
              <td v-for="(item, idx) in fixedSlots" :key="'action-' + idx"
                  :class="{ 'empty-col': !item }">

                <button v-if="item"  class="contact-btn" @click="goToContact(item)" 
                style="
                      padding:7px 12px;
                      border-radius: 48px;
                      font-size: 16px;
                      color: #2655AE;
                      border: 1px solid #cce0ff;
                      background-color: #B5C8FF26;
                      cursor: pointer;
                      ">
                    联系我们
                  </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GoodsListTitle from '../../components/goods/GoodsListTitle.vue'

export default {
  components: { GoodsListTitle },
  name: "GoodsCompare",
  data() {
    return {
      classname: "产品对比",
      showDiffOnly: localStorage.getItem('goodsCompare_showDiffOnly') === 'true',
      goodsList: [],          // 存放从接口获取的商品列表（按ID维度）
      labelMap: {},           // 存放字段key -> 中文label的映射
      mockGoods: []           // 可选的mock数据，暂时留空
    };
  },
  watch: {
    showDiffOnly(val) {
      localStorage.setItem('goodsCompare_showDiffOnly', val);
    },
    // 监听版本号变化，从其他页面增删对比商品后自动重新拉取数据
    compareListVersion: {
      handler() {
        this.fetchCompareData();
      }
    }
  },
  computed: {
    ...mapGetters(["compareList", "compareListVersion"]),
    // 最终用于展示的商品列表（优先接口数据，其次vuex，最后mock）
    compareGoods() {
      if (this.goodsList && this.goodsList.length > 0) {
        return this.goodsList;
      }
      // if (this.compareList && this.compareList.length > 0) {
      //   return this.compareList;
      // }
      return this.mockGoods;
    },
    // 对比行数据：根据第一个商品的parameter字段生成，并使用labelMap显示中文
    compareRows() {
      if (this.compareGoods.length === 0) return [];
      const first = this.compareGoods[0];
      // 如果第一个商品没有parameter，返回空
      if (!first.parameter) return [];
      const keys = Object.keys(first.parameter);
      return keys.map(key => ({
        label: this.labelMap[key] || key,   // 优先使用中文映射，没有则显示key
        key
      }));
    },
    // 固定4个商品槽位（用于表头显示）
    fixedSlots() {
      const slots = [];
      for (let i = 0; i < 4; i++) {
        slots.push(this.compareGoods[i] || null);
      }
      return slots;
    }
  },
  methods: {
    // 从接口拉取对比商品数据
    fetchCompareData() {
      if (!this.compareList || this.compareList.length === 0) {
        this.goodsList = [];
        // 对比列表被清空时提示并跳转首页
        // this.$message.warning("暂无对比产品");
        this.$router.push({ name: 'index' });
        return;
      }
      const goodsIds = this.compareList.map(item => item.id).join(',');
      this.$api.goods.getCompare(goodsIds).then(res => {
        if (res.data && res.data.datas) {
          this.goodsList = res.data.datas.products || [];
          this.labelMap = res.data.datas.label_map || {};
        }
      }).catch(err => {
        console.error('获取对比产品失败:', err);
      });
    },
    // 获取某个商品在某个行（row）上的值（保留sub/sup/br标签用于v-html渲染下标上标和换行）
    getCellVal(row, item) {
      if (!item || !item.parameter) return "";
      const val = item.parameter[row.key];
      if (val === undefined || val === null) return "";
      // 换行符转<br>，只保留sub/sup/br标签，去掉其他HTML标签避免XSS
      return String(val)
        .replace(/\n/g, '<br>')
        .replace(/<br\s*\/?>/gi, '<br>')
        .replace(/<(?!\/?(?:sub|sup|br)\b)[^>]*>/gi, '');
    },
    // 获取单元格纯文本值（去掉所有HTML标签），用于title属性鼠标悬停提示
    getCellTitle(row, item) {
      if (!item || !item.parameter) return "";
      const val = item.parameter[row.key];
      if (val === undefined || val === null) return "";
      return String(val).replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]*>/g, '');
    },
    // 规范化值：去除标点符号和多余空白，只保留文字内容用于差异对比
    normalizeVal(val) {
      if (val === undefined || val === null) return "";
      return String(val)
        .replace(/<[^>]*>/g, '') // 先去掉HTML标签（如<br>），避免标签里的字母干扰差异对比
        .replace(/°\s*[cCfF]/g, '') // 去掉°C/°F等温度符号后的字母（用户填写时℃和°C混用，避免字母C残留导致差异）
        .replace(/≤/g, '<=') // 统一小于等于写法：≤ -> <=
        .replace(/≥/g, '>=') // 统一大于等于写法：≥ -> >=
        .replace(/[^\u4e00-\u9fa5a-zA-Z0-9<>=]/g, '') // 去除标点空格等，但保留<>=比较运算符（避免≤10和≥10被判为相同）
        .toLowerCase(); // 忽略大小写差异
    },
    // 判断整行是否有差异（任一商品与第一个不同，对比时忽略标点符号）
    isDiffRow(row) {
      if (this.compareGoods.length < 2) return false;
      const firstVal = this.normalizeVal(this.getCellVal(row, this.compareGoods[0]));
      return this.compareGoods.some(item => this.normalizeVal(this.getCellVal(row, item)) !== firstVal);
    },
    // 判断某个单元格是否有差异（与第一个商品该字段对比，对比时忽略标点符号）
    isDiffCell(row, item) {
      if (!item || this.compareGoods.length < 2) return false;
      const firstVal = this.normalizeVal(this.getCellVal(row, this.compareGoods[0]));
      return this.normalizeVal(this.getCellVal(row, item)) !== firstVal;
    },
    // 移除商品
    removeGoods(id) {
      if (this.compareGoods.length <= 1) {
        this.$message.warning("至少保留一个对比产品");
        return;
      }
      this.$store.commit("removeCompareGoods", id);
      // 如果是通过接口数据加载的，可手动过滤goodsList（根据业务需要）
      if (this.goodsList.length > 0) {
        this.goodsList = this.goodsList.filter(item => item.id !== id);
      }
    },
    // 跳转到商品列表页添加商品，携带当前对比产品的分类参数
    goToAdd() {
      const firstGoods = this.compareList && this.compareList[0];
      if (firstGoods && firstGoods.idx_cid1) {
        // 使用第一个对比商品的分类ID作为pid，classid=0表示该大类下所有产品
        const pid = firstGoods.idx_cid1;
        const classid = 0;
        // TODO: classname需要从接口或本地映射获取，暂时用空字符串占位
        const classname = this.getCategoryName(pid) || '产品';
        this.$router.push('/goods/list/' + pid + '/' + classid + '/' + classname);
      } else {
        // 没有对比商品时，跳转到默认分类页
        this.$router.push('/class/index/1');
      }
    },

    // 根据分类ID获取分类名称（本地映射）
    getCategoryName(pid) {
      const categoryMap = {
        1: 'RV减速机',
        2: '伺服电机',
        3: '伺服驱动器',
        4: '并联机器人',
        6: '串联机器人',
        7: '协作机器人',
        8: '真空元件',
        9: '控制系统',
        10: '机器视觉系统'
      };
      return categoryMap[pid] || '';
    },
    // 跳转到商品详情页
    goToGoodsInfo(goodsid) {
      const routeData = this.$router.resolve({ name: "goodsinfo", params: { goodsid: goodsid } });
      window.open(routeData.href, '_blank');
    },
    // 跳转到联系我们页面
    goToContact(item) {
      localStorage.setItem('bannerimg', item.brandimg || '');
      localStorage.setItem('imgurl', item.pic || '');
      localStorage.setItem('goodsId', item.id || '');
      this.$router.push({ name: 'helpcooperationgoods' });
    }
  },
  mounted() {
    // 对比列表为空时提示并跳转首页
    if (!this.compareList || this.compareList.length === 0) {
      this.$message.warning("暂无对比产品");
      this.$router.push({ name: 'index' });
      return;
    }
    // 请求对比数据
    const goodsIds = this.compareList.map(item => item.id).join(',');
    this.$api.goods.getCompare(goodsIds).then(res => {
      if (res.data && res.data.datas) {
        // 后端返回结构： { products: [...], label_map: {...} }
        this.goodsList = res.data.datas.products || [];
        this.labelMap = res.data.datas.label_map || {};
      }
    }).catch(err => {
      console.error('获取对比产品失败:', err);
    });
  }
};
</script>

<style scoped>
.goods-compare-page-bg {
  background: #F4F5F7;
  min-height: 100vh;
}

.goods-compare {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0px 16px 40px 16px;
  min-height: 600px;
}

.compare-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #999;
  margin-bottom: 16px;
}

.compare-header a {
  color: #2655AE;
  text-decoration: none;
}

.compare-header a:hover {
  text-decoration: underline;
}

.diff-label {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: #333;
}

.diff-label input {
  margin-top: 5px;
}
.diff-checkbox{
  appearance: none;
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  border: 1px solid #999999;
  border-radius: 2px;
  background-color: #F4F5F7;
  cursor: pointer;
  position: relative;
  vertical-align: middle;
}
.diff-checkbox:checked{
  border-color: #2655AE;
  background-color: #F4F5F7;
}
.diff-checkbox:checked::after{
  content: '';
  position: absolute;
  left: 4px;
  top: 0px;
  width: 3.5px;
  height: 8px;
  border: solid #2655AE;
  border-width: 0 1px 1px 0;
  transform: rotate(45deg);
}


.compare-title {
  font-size: 16px;
  color: #333;
  margin: 12px 0;
}

.compare-table-wrap {
  overflow-x: auto;
  /* 阴影 */
  box-shadow: 0px 10px 25px 0px #00256A26;
}

.compare-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  background: #fff;
}

.compare-table th,
.compare-table td {
    border: 1px solid #BED5FF;
    padding: 0 12px;
    text-align: center;
    vertical-align: middle;
    font-size: 16px;
    color: #333;
    /* word-break: break-all; */
    height: 68px;
  
}

.compare-table .label-col {
  width: 160px;
  min-width: 160px;
  font-weight: 700;
  color: #2655AE;
  background: #fff;
  font-size: 16px;
  /* background: #f7f8fa;
  font-weight: 600;
  color: #2655AE;
  text-align: center; */
  /* padding-left: 16px; */
}

/* .compare-table thead th {
  background: #f7f8fa;
  font-weight: 600;
} */

/* .goods-thumb {
  position: relative;
} */   /* display: inline-block; */


.goods-thumb img {
  width: 150px;
  height: 150px;
  object-fit: cover;
  /* border: 1px solid #eee; */
  border-radius: 4px;
  cursor: pointer;
}
.goods-col {
  position: relative;
  padding: 25px 12px!important;
}
/* .goods-thumb  */
.remove-btn {
  position: absolute;
  top: 9px;
  right: 7px;
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.remove-btn img {
  width: 100%;
  height: 100%;
}

/* .goods-thumb .remove-btn:hover {
  color: #f56c6c;
  border-color: #f56c6c;
} */

.diff-row {
  background: #BED5FF;

}

.diff-cell {
  background: #BED5FF;
  border: 1px solid #FFFFFF!important;
  /* font-weight: 600; */
}

/* 空列样式 - 两种风格可切换 */
/* 风格A：空列不显示背景色（白色），与有数据的列区分明显 */
.empty-col {
  background: #fff;
  border: 1px solid #BED5FF!important;
}
/* 风格B：空列也显示蓝色背景，与diff-row保持一致，取消下面注释即可 */
/* .empty-col {
  background: #BED5FF;
} */

/* 特点行：文字靠左，垂直居中 */
.feature-cell {
  font-size: 16px!important;
  align-items: center!important;
  justify-content: flex-start!important;
  padding: 22px 19px!important;
  text-align: left!important;
  white-space: pre-wrap;
}

.feature-text {
  white-space: pre-wrap;
}

.cell-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: pre-line;
}

.empty-hint {
  text-align: center;
  padding: 60px 0;
  color: #999;
  font-size: 16px!important;
}

.add-goods-cell {
  color: #FBB113;
  font-size: 16px!important;
  font-weight: 400!important;
  cursor: pointer;
  /* 
  user-select: none; */
}


</style>



// WEBPACK FOOTER //
// src/views/goods/GoodsCompare.vue